import { Component, OnInit } from '@angular/core';
import { CiacService } from 'src/app/services/http/ciac.service';
import { Router } from '@angular/router';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';

@Component({
  selector: 'app-lista-conversoes',
  templateUrl: './lista-conversoes.component.html',
  styleUrls: ['./lista-conversoes.component.scss']
})
export class ListaConversoesComponent implements OnInit {

  sorting: { 
    id: "asc",
    nome: ""
  }

  filter = {
    sorting: { 
      id: "asc",
      nome: ""
    },
    filter: {
      nome: ""
    },
    data: new Date(),
    page: 1,
    per_page: 10,
  };
  
  total:number = 0;
  tableLoading = false;
  listaConversoes = [];

  constructor(private ciacService: CiacService, private router: Router, private modalMsgService: ModalMsgService, private modalService: NgbModal) { }

  ngOnInit() {
    this.getListaConversoes();
  }

  removeEmpty(obj) {
    this.listaConversoes = [];
    Object.keys(obj).forEach((key) => (obj[key] == '') && delete obj[key]);
    return obj;
  }

  getListaConversoes() {
    this.filter.sorting = this.removeEmpty({ ...this.sorting });
    let dataUpdate = this.filter.data;
    this.ciacService.getListaConversao(this.filter).then(c => {
      if(dataUpdate == this.filter.data) {
        this.tableLoading = false;
        this.total = c.total || 0;
        this.listaConversoes = this.listaConversoes.concat(c.lista);
      }
    });

    if(this.listaConversoes.length == 0) {
      this.tableLoading = false;
    }
  }

  setPageSize(pageSize) {
    this.filter.page = 1;
    this.filter.per_page = pageSize;
    this.getListaConversoes();
  }

  nextPage() {
    this.getListaConversoes();
  }

  redirectEdit(id) {
    this.router.navigate(['ciac', 'conversao', 'editar', id ]);
  }

  delConversao(id) {
    let params = {
      id: parseInt(id)
    }
    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Remover Conversão';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.ciacService.delConversao(justificativa, params)
          .then(r => this.getListaConversoes())
          .catch(e => this.modalMsgService.openDialog('Erro ao remover conversão', '', 'danger'));
      } else {
        this.modalMsgService.openDialog('Erro ao remover conversão',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao remover conversão',
      'Informe uma Justificativa para concluir a operação', 'danger'));
  }

}
